import { motion } from "framer-motion";
import { PROJECTS_DATA } from "@/data/projects";
import ProjectCard from "@/components/ProjectCard";
import { PROJECTS } from "@/constants/testIds";

export default function FeaturedProjects() {
  return (
    <section
      id="work"
      data-testid={PROJECTS.section}
      className="relative py-24 lg:py-40"
    >
      <div className="max-w-[1500px] mx-auto px-5 lg:px-10">
        {/* Section header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-end mb-16 lg:mb-28">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-8"
          >
            <div className="font-mono-tag text-xs text-[#E2FF31] mb-6">
              // 001 — Selected Client Work
            </div>
            <h2 className="font-display font-medium text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.95]">
              Websites clients are
              <br />
              <span className="text-white/40">proud to send traffic to.</span>
            </h2>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="lg:col-span-4 text-white/60 text-base leading-relaxed"
          >
            Three recent builds — a live wellness platform, a luxury salon
            concept and an AI-powered café — each shipped end-to-end on React,
            FastAPI and MongoDB. Open any project in a new tab, or use the
            &lsquo;Request Similar Website&rsquo; button to brief the same build
            for your brand.
          </motion.div>
        </div>

        {/* Project cards */}
        <div className="space-y-28 lg:space-y-48">
          {PROJECTS_DATA.map((project, idx) => (
            <ProjectCard key={project.slug} project={project} index={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}
